module.exports = __webpack_public_path__ + "img/terroir-moonlit-3.31c2ae66.jpg";